module.exports = __webpack_public_path__ + "img/coinbankC26.97add032.jpg";